import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { debounceTime, merge, Subject } from 'rxjs';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from '../../shared/service/notification.service';
import { OrderHistorySalesService } from '../order-history-sales.service';
import { OrderHistorySalesDataSource } from '../order-history-sales.data-source';
import { MatButtonToggleChange } from '@angular/material/button-toggle';

@Component({
  selector: 'app-order-overview',
  templateUrl: './order-overview-sales.component.html',
  styleUrls: ['./order-overview-sales.component.scss']
})
export class OrderOverviewSalesComponent implements AfterViewInit, OnInit {

  private searchInputSubject = new Subject<string>();
  public searchInput = this.searchInputSubject.asObservable();
  public searchText = '';
  private searchEmpty = true;
  public searchField: string = 'number';
  public tableColumns: string[] = [
    'orderSequence',
    'orderNumber',
    'createdAt',
    'createdBy',
    'organization',
    'type',
    'sap'
  ];

  public sortActiveDefault = 'orderSequence';
  public sortDirectionDefault: SortDirection = 'desc';
  public pageSizeOptions: number[] = [15, 30, 50];
  public totalItems = 0;
  public dataSource: OrderHistorySalesDataSource;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private orderHistoryService: OrderHistorySalesService,
    private dialog: MatDialog,
    private notificationService: NotificationService
  ) {
    this.dataSource = new OrderHistorySalesDataSource(orderHistoryService);

    this.dataSource.dataLength.subscribe((total) => {
      this.totalItems = total
    });
  }

  ngOnInit(): void {
    this.loadData();
  }

  ngAfterViewInit() {
    // Reset pagination after sort change.
    this.sort.sortChange
      .subscribe(() => this.paginator.pageIndex = 0);

    // Load data when a sort or paginator event is emitted.
    merge(this.sort.sortChange, this.paginator.page)
      .subscribe(() => this.loadData());

    // Load data when search input value changes.
    this.searchInput
      .pipe(
        debounceTime(150)
      )
      .subscribe((value) => {
        if (!this.searchEmpty || value.length) {
          this.paginator.pageIndex = 0;
          this.loadData()
        }

        this.searchEmpty = value.length === 0;
      });
  }

  public onSearch(): void {
    this.searchInputSubject.next(this.searchText);
  }

  public onSearchClear(): void {
    this.searchText = '';
    this.onSearch();
  }

  public onChangeFilterType(event: MatButtonToggleChange): void {
    this.onSearchClear();
  }

  private loadData() {
    this.dataSource.loadOrderHistorySales(
      this.paginator?.pageIndex + 1 || 1,
      this.paginator?.pageSize || this.pageSizeOptions[0],
      this.sort?.active || this.sortActiveDefault,
      this.sort?.direction || this.sortDirectionDefault,
      this.searchText,
      this.searchField
    );
  }
}
